// client/src/api/agreementApi.js
import { API_URL } from '../config/apiConfig';

export const agreementApi = {
    /**
     * Get all agreements (admin only)
     */
    async getAgreements(token) {
        try {
            const response = await fetch(`${API_URL}/agreements`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Failed to fetch agreements');
            }

            return await response.json();
        } catch (error) {
            console.error('Failed to fetch agreements:', error);
            throw error;
        }
    },

    /**
     * Get all affiliates for dropdown (admin only)
     */
    async getAffiliates(token) {
        try {
            const response = await fetch(`${API_URL}/agreements/affiliates`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Failed to fetch affiliates');
            }

            return await response.json();
        } catch (error) {
            console.error('Failed to fetch affiliates:', error);
            throw error;
        }
    },

    /**
     * Get agreement by affiliate ID
     */
    async getAgreementByAffiliate(token, affiliateId) {
        try {
            const response = await fetch(`${API_URL}/agreements/affiliate/${affiliateId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Failed to fetch agreement');
            }

            return await response.json();
        } catch (error) {
            console.error('Failed to fetch agreement:', error);
            throw error;
        }
    },

    /**
     * Create new agreement (admin only)
     */
    async createAgreement(token, agreementData) {
        try {
            const response = await fetch(`${API_URL}/agreements`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(agreementData)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Failed to create agreement');
            }

            return await response.json();
        } catch (error) {
            console.error('Failed to create agreement:', error);
            throw error;
        }
    },

    /**
     * Update agreement (admin only)
     */
    async updateAgreement(token, id, agreementData) {
        try {
            const response = await fetch(`${API_URL}/agreements/${id}`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(agreementData)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Failed to update agreement');
            }

            return await response.json();
        } catch (error) {
            console.error('Failed to update agreement:', error);
            throw error;
        }
    },

    /**
     * Delete agreement (admin only)
     */
    async deleteAgreement(token, id) {
        try {
            const response = await fetch(`${API_URL}/agreements/${id}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Failed to delete agreement');
            }

            return await response.json();
        } catch (error) {
            console.error('Failed to delete agreement:', error);
            throw error;
        }
    },

    /**
     * Accept agreement
     */
    async acceptAgreement(token, id) {
        try {
            const response = await fetch(`${API_URL}/agreements/${id}/accept`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || 'Failed to accept agreement');
            }

            return await response.json();
        } catch (error) {
            console.error('Failed to accept agreement:', error);
            throw error;
        }
    }
};